const logotext = "BHAVIK";
const meta = {
    title: "Bhavik Jain",
    description: "I’m Bhavik Jain Full Stack Devloper | Competitive Programmer | Data Scientist",
};

const introdata = {
    title: "I’m Bhavik Jain",
    animated: {
        first: "I develop Web Applications . . .",
        second: "I am interested in Competitive Programming",
    },
    description: "I am a self-taught, passionate Web Dev from India. I enjoy working with new technologies and developing Web Applications. As a location independent Developer, I am happy to work with people all over the globe !!",
    your_img_url: "assets/images/pic2.png",
    resume_url: "assets/images/Resume.pdf"
};

const dataabout = {
    title: "Know me",
    aboutme: "I am Bhavik, a passionate Web Dev. I have keen interest in Full Stack development and Competitive Programming.<br/> My tech stack includes Web development using <strong>MERN stack</strong> and <strong>Python frameworks</strong>.<br/> I’m looking to apply my skills in a good million dollar idea! So if you have any, let's collaborate.<br/> Fun Fact: I am always ready for a game of chess",
};

const skills = [
    {
        name: "MERN Stack",
        value: 90,
    },
    {
        name: "Bootstrap | Tailwind",
        value: 90,
    },
    {
        name: "Python",
        value: 85,
    },
    {
        name: "HTML | CSS | JS",
        value: 80,
    },
    {
        name: "VueJs | NextJs",
        value: 80,
    },
];

const services = [
    {
        title: "Designing",
        description: "I can help you by suggesting design ideas and also develop the design on Figma",
    },
    {
        title: "UI | UX Development",
        description: "I am capable of converting the design into code",
    },
    {
        title: "Web Applications",
        description: "I can develop entire web application as per the requirement",
    },
    {
        title: "Deploying and Hosting",
        description: "After developing the application, its time for deployment. I can help in hosting the application on sites like Heroku, Netlify, etc.",
    },
];

const dataportfolio = [
    {
        img: "assets/images/fintrack.png",
        desctiption: "FinTrack is a finance management website which has multiple features such as managing expenses and budgets, calculating EMI, portfolio overview, stock recommendations and much more",
        link: "https://fin-track.vercel.app",
    },
    {
        img: "assets/images/incento.png",
        desctiption: "Incento is a promotion engine that enables small and large scale businesses to generate static as well as dynamic coupons and easily integrate them with their websites.",
        link: "https://incento.netlify.app",
    },
    {
        img: "assets/images/taskmann.png",
        desctiption: "Taskmann is a materialistic and clean task manager application developed using MERN Stack",
        link: "https://taskmann.netlify.app",
    },
    {
        img: "assets/images/resto-fusion.png",
        desctiption: "Restaurant website developed using React served by json-server",
        link: "https://resto-fusion.netlify.app",
    }
];

const contactConfig = {
    description: "Got an Idea or Want to ask something? Don't hesitate to contact me.",
    YOUR_SERVICE_ID: "service_offcetc",
    YOUR_TEMPLATE_ID: "bhavik_portfolio_form",
    YOUR_USER_ID: "SubL4KIvKZQtWXF-D",
};

const socialprofils = {
    github: "https://github.com/bhavikjain403",
    linkedin: "https://www.linkedin.com/in/bhavik-jain-0a9ba0217",
    codechef: "https://www.codechef.com/users/thebhavikjain",
    codeforces: "https://codeforces.com/profile/bhavikjain403",
    leetcode: "https://www.leetcode.com/bhavikjain403",
};

const cp = [
    {
        img: "https://cdn.jsdelivr.net/npm/simple-icons@3.1.0/icons/codechef.svg",
        link: "https://www.codechef.com/users/thebhavikjain",
    },
    {
        img: "https://raw.githubusercontent.com/rahuldkjain/github-profile-readme-generator/master/src/images/icons/Social/codeforces.svg",
        link: "https://codeforces.com/profile/bhavikjain403",
    },
    {
        img: "https://user-images.githubusercontent.com/36547915/97088991-45da5d00-1652-11eb-900f-80d106540f4f.png",
        link: "https://www.leetcode.com/bhavikjain403",
    },
]

const cert = [
    {
        img: "assets/images/webdev.png",
        desctiption: "Introduction to Web Development with HTML, CSS, JavaScript",
        link: "https://www.coursera.org/account/accomplishments/certificate/88GWWP8SB3MB",
    },
    {
        img: "assets/images/react.png",
        desctiption: "React",
        link: "https://www.coursera.org/account/accomplishments/certificate/FZFRDQRVEH4Z",
    },
    {
        img: "assets/images/javascript.png",
        desctiption: "JavaScript Basics",
        link: "https://www.coursera.org/account/accomplishments/certificate/S8YGY83PA8B5",
    },
    {
        img: "assets/images/AWS-cloud.png",
        desctiption: "AWS Cloud Foundations",
        link: "https://www.credly.com/go/gWM0vrdE",
    },
    {
        img: "assets/images/AI.png",
        desctiption: "AI For Everyone",
        link: "https://www.coursera.org/account/accomplishments/certificate/VNVMUXM8YEHR",
    },
    {
        img: "assets/images/bootstrap.png",
        desctiption: "Bootstrap",
        link: "https://www.coursera.org/account/accomplishments/certificate/TUELG8WAUTH7",
    },
    {
        img: "assets/images/AWS-ML.png",
        desctiption: "AWS Machine Learning Foundations",
        link: "https://www.credly.com/badges/1dbf94f0-08ef-4970-97b3-b34d620e3448/public_url",
    },
    {
        img: "assets/images/AWS-CloudArch.png",
        desctiption: "AWS Cloud Architecting",
        link: "https://www.credly.com/badges/353ee727-b8d2-4abb-9a95-3889d0796a6e/public_url",
    },
    {
        img: "assets/images/udemy-c.jpg",
        desctiption: "C# Fundamentals",
        link: "https://www.udemy.com/certificate/UC-99c24b46-0069-4e1d-b466-fe1ca810c01e/",
    },
]

export {
    meta,
    dataabout,
    dataportfolio,
    skills,
    services,
    introdata,
    contactConfig,
    socialprofils,
    logotext,
    cp,
    cert,
};
